import { render } from "./BlockSelect.vue?vue&type=template&id=567d431a&scoped=true"
import script from "./BlockSelect.vue?vue&type=script&lang=js"
export * from "./BlockSelect.vue?vue&type=script&lang=js"

import "./BlockSelect.vue?vue&type=style&index=0&id=567d431a&scoped=true&lang=css"

import exportComponent from "C:\\llx\\1-it\\mahjong-vue-PWA-PR\\mahjong-vue-PWA-PR\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567d431a"]])

export default __exports__